import { render, staticRenderFns } from "./PromoCategoryNew.vue?vue&type=template&id=94d083c0&scoped=true&"
import script from "./PromoCategoryNew.vue?vue&type=script&lang=js&"
export * from "./PromoCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d083c0",
  null
  
)

export default component.exports